import Component from '../core/Component'

export default class SectionServicesSlider extends Component {
    constructor(element, options) {
        super(element, options)
        
        this.ref = {
            links: [],
            list: null,
            items: []
        }

        this.index = null
    }

    prepare() {
        const index = this.ref.items.findIndex(item => item.classList.contains('is-active'))
        if (index <= 0) {
            this.index = index
        }

        this.ref.links.forEach((link,index) => link.addEventListener('click', event => this.handleLinkClick(index,event)))

        this.resize()
        this.element.classList.add('is-ready')
    }

    handleLinkClick = (index, event) => {
        event.preventDefault()
        this.select(index)
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.ref.items.forEach((item,_index) => {
            if (index === _index) {
                item.classList.add('is-active')
            } else{
                item.classList.remove('is-active')
            }
        })

        this.ref.links.forEach((link,_index) => {
            link.classList.toggle('is-active', index === _index)
        })

        this.index = index
        this.resize()
    }

    resize() {
        if (this.index === null) {
            return
        }
        const itemRect = this.ref.items[this.index].getBoundingClientRect()
        this.ref.list.style.height = `${itemRect.height}px`
    }
}